<div class="flex flex-row w-full h-full">
    <div class="flex items-center w-1/5 border-r border-slate-300">
        <ng-content select="#menuSection"></ng-content>
    </div>
    <div class="h-full grow">
        <ng-content></ng-content>
    </div>
</div>